module.exports = __webpack_public_path__ + "img/docusign.ae162ff7.svg";